import { createAction, props } from '@ngrx/store';
import { Cart, CartItem } from '@b2b/features/cart/utilities/cart.model';

// GET CART

export const GET_CART = '[CART]: GET';
export const GET_MINI_CART = '[CART]: GET MINICART';
export const GET_OR_CREATE_CART = '[CART]: GET OR CREATE';
export const GET_LATEST_CART = '[CART]: GET LATEST';
export const GET_CART_SUCCESS = '[CART]: GET - SUCCESS';
export const GET_CART_FAIL = '[CART]: GET - FAIL';
export const GET_CART_PRISTINE = '[CART]: GET - PRISTINE';

export const getLatestCart = createAction(GET_LATEST_CART, props<{ customerId?: string }>());
export const getOrCreateCart = createAction(GET_OR_CREATE_CART);
export const getMiniCart = createAction(GET_MINI_CART, props<{ cartID: string }>());
export const getCart = createAction(GET_CART, props<{ cartID: string }>());
export const getCartSuccess = createAction(GET_CART_SUCCESS, props<{ data: Cart }>());
export const getCartFail = createAction(GET_CART_FAIL, props<{ message: string }>());
export const getCartPristine = createAction(GET_CART_PRISTINE);

export const UPDATE_CART = '[CART]: UPDATE CART';
export const updateCart = createAction(UPDATE_CART, props<{ name: string }>());

// ADD CART ITEM
export const ADD_CART_ITEM = '[CART]: ADD CART ITEM';

export const addCartItem = createAction(ADD_CART_ITEM, props<{ item: CartItem }>());

// UPDATE CART ITEM
export const UPDATE_CART_ITEM = '[CART]: UPDATE CART ITEM';
export const UPDATE_CART_ITEM_SUCCESS = '[CART]: UPDATE CART ITEM - SUCCESS';
export const UPDATE_CART_ITEM_FAIL = '[CART]: UPDATE CART ITEM - FAIL';

export const updateCartItem = createAction(UPDATE_CART_ITEM, props<{ entryNumber: number; item: CartItem }>());
export const updateCartItemSuccess = createAction(UPDATE_CART_ITEM_SUCCESS, props<{ data: Cart }>());
export const updateCartItemFail = createAction(UPDATE_CART_ITEM_FAIL, props<{ message: string }>());

// DELETE CART ITEM
export const DELETE_CART_ITEM = '[CART]: DELETE CART ITEM';
export const DELETE_CART = '[CART]: DELETE CAR';

export const deleteCartItem = createAction(DELETE_CART_ITEM, props<{ entryNumber: number; cartCode: string }>());
export const deleteCart = createAction(DELETE_CART, props<{ cartCode: string }>());

// SAVE CART
export const SAVE_CART = '[CART]: SAVE CART';

export const saveCart = createAction(SAVE_CART, props<{ name: string }>());
